import type { PnrLocatorRequest as PnrRequest } from "@jb-manage-trips/types/pnr";
import { sixCharAlphanumeric, isTicketNumber } from "./confirmation";

export function generatePnrServiceRequestSchema(formValue: {
  confirmationCode: string;
  lastName: string;
  dob?: string; // MM/DD/YYYY
}): PnrRequest {
  let confirmationBlock: Partial<
    Record<keyof PnrRequest["b6PNRLocatorRQ"], string>
  > = {};

  if (sixCharAlphanumeric.test(formValue.confirmationCode)) {
    confirmationBlock = { pnrRecordLocator: formValue.confirmationCode };
  } else if (isTicketNumber(formValue.confirmationCode)) {
    confirmationBlock = { ticketNumber: formValue.confirmationCode };
  }

  let dobIso: string | undefined;
  if (formValue.dob) {
    const [mm, dd, yyyy] = formValue.dob.split("/");
    if (yyyy && mm && dd) {
      dobIso = `${yyyy}-${mm}-${dd}`;
    }
  }

  return {
    b6PNRLocatorRQ: {
      ...confirmationBlock,
      isNonB6: false,
      lastName: formValue.lastName,
      ...(dobIso ? { dob: dobIso } : {}),
    },
  };
}
